"use strict";
var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var ui_extensions = require("ui-extensions");
var editor_2d = require("editor-2d");

var HoleInteractionModel = require("../../../shared/extensions/footprintViewer/holeInteractionModel.js");
var PadInteractionModel = require("../../../footprint-editor/extensions/padViewer/padInteractionModel.js");
var SolderMaskInteractionModel = require("../../../shared/extensions/solderMask/solderMaskViewer/solderMaskInteractionModel.js");
var SolderPasteInteractionModel = require("../../../shared/extensions/solderPaste/solderPasteViewer/solderPasteInteractionModel.js");
var GlueInteractionModel = require("../../../shared/extensions/glue/glueViewer/glueInteractionModel.js");
var RestrictInteractionModel = require("../../../shared/extensions/restrict/restrictViewer/restrictInteractionModel.js");

var FootprintInteractionModel = function(footprintInstance, editorModel) {
    var self = this;
    editor_2d.AbstractSelectableInteractionModel.call(this, footprintInstance, editorModel);

    this.data = footprintInstance;
    this.footprintData = this.data.description;

    this.origin = editorModel.origin();

    this.interactionModelMap = this.map("interactionModelMap", true);
    var buildIM = function(){
        self.interactionModelMap.removeAll();
        buildIMsForCollection(self.footprintData().holes, HoleInteractionModel);
        buildIMsForCollection(self.footprintData().pads, PadInteractionModel);
        buildIMsForCollection(self.footprintData().solderMask, SolderMaskInteractionModel);
        buildIMsForCollection(self.footprintData().solderPaste, SolderPasteInteractionModel);
        buildIMsForCollection(self.footprintData().glue, GlueInteractionModel);
        buildIMsForCollection(self.footprintData().copperRestricts, RestrictInteractionModel);
        buildIMsForCollection(self.footprintData().componentRestricts, RestrictInteractionModel);
        buildIMsForCollection(self.footprintData().viaRestricts, RestrictInteractionModel);
    };
    buildIM();
    this.footprintData.onChange(this, buildIM);

    this.version = this.shadow("version",
        function() {
            return self.data.ancestor().root.header["version"];
        }, null,
        [self.data.ancestor]);
    this.versions = this.value("versions", true);
    this.versions([]);
    this.versionsLoaded = this.value("versionsLoaded", true);
    this.versionsNotLoaded = this.shadow("versionsNotLoaded",    // TODO see if we can get rid of this to save (a little) memory
        function() {
            return !self.versionsLoaded();
        }, null,
        [this.versionsLoaded]);

    function buildIMsForCollection (collection, IMconstructor) {
        collection.forEach(function(k, element) {
            var IM = new IMconstructor(element, editorModel);
            self.interactionModelMap.put(element, IM);
        })
    }
};
lib_core.inherit(FootprintInteractionModel, editor_2d.AbstractSelectableInteractionModel);
FootprintInteractionModel.$class = "FootprintInteractionModel";

module.exports = FootprintInteractionModel;

FootprintInteractionModel.prototype.getVersionsOptions = function(asset) {
    var versions = asset.getVersions().map(function(save_point) {
        return [save_point.name, save_point.version];
    });
    return versions;
};

FootprintInteractionModel.prototype.getInspectorElements = function () {
    var self = this;

    this.versionsLoaded(false);
    this.data.ancestor().root.getAsset()    //load content from server
    .then(function(asset) {
        self.versions(self.getVersionsOptions(asset));
        self.versionsLoaded(true);
    });

    var inspectorElements = {};
    inspectorElements.input_elements = [];

    var instance = this.data;
    var editCEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ASSET_EDIT).element(instance);
    var updateCEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ASSET_UPDATE).element(instance);
    var forkCEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ASSET_FORK).element(instance);
    inspectorElements.input_elements.push(
        {
            label      : 'Open in editor',
            type       : ui_extensions.InspectorInputType.BUTTON,
            cEvent     : editCEvent
        },
        {
            label      : 'Fork and replace',
            type       : ui_extensions.InspectorInputType.BUTTON,
            cEvent     : forkCEvent
        },
        {
            label      : 'Versions loading',
            type       : ui_extensions.InspectorInputType.SPINNER,
            visible    : this.versionsNotLoaded
        },
        {
            label      : 'Update version',
            type       : ui_extensions.InspectorInputType.SELECTBOXEVENT,
            list       : this.versions,
            cEvent     : updateCEvent,
            init       : this.version(),
            visible    : this.versionsLoaded
        }
    );

    inspectorElements.help_elements = {
        'name': 'Footprint Inspector'
    };
    return inspectorElements;
};
